import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useClaimHead } from './HeadDefaults';

/**
 * Head for a page whose record is gone (a deleted supplier or yard). Without it Google
 * sees a 200 "not found" page and reports a soft 404 (securspace-ui#3107). noindex
 * drops it now; prerender-status-code makes prerender answer crawlers with a 404,
 * which they see once CloudFront stops turning 404s into 200s (securspace-aws#56).
 */
const NotFoundHead = ({ title }: { title: string }) => {
  // It renders a <title>, so it claims the head like every page SEO component.
  useClaimHead();
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="robots" content="noindex" />
      <meta name="prerender-status-code" content="404" />
    </Helmet>
  );
};

export default NotFoundHead;
